// extracted by mini-css-extract-plugin
export var scopedSearchResultInnerStyle = "search_instant_dropdown_wrapper-module--scopedSearchResultInnerStyle--vWhMt";
export var scopedSearchResultWrapperStyle = "search_instant_dropdown_wrapper-module--scopedSearchResultWrapperStyle--KJnIc";